//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  ActionBase,
  Illustration,
  Paper,
  Tag,
  Typography,
} from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { Prices } from '@app/components/prices'
import { COUNTRIES } from '@config/constants'
import VanishingTimer from '@vanishing/components/VanishingTimer'

import productThumbTranslations from '../ProductThumb.translations'

import translations from './List.translations'

export const COUNTRIES_WITH_EXTENDED_DISPLAY = [COUNTRIES.FR]

export default {
  components: {
    ActionBase,
    Illustration,
    Paper,
    Prices,
    Tag,
    Typography,
    VanishingTimer,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    attributes: {
      type: Array,
      required: true,
    },
    isRecommendation: {
      type: Boolean,
      default: false,
    },
    isVanishing: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Object,
      required: true,
    },
    thumbnail: {
      type: String,
      required: true,
    },
    /**
     * Before Backmarket's price
     *
     * @typedef {object} price
     * @property {number} price.raw
     * @property {string} price.display
     */
    price: {
      type: Object,
      required: true,
    },
    /**
     * Before Backmarket's price
     *
     * @typedef {object} originalPrice
     * @property {number} originalPrice.raw
     * @property {string} originalPrice.display
     */
    originalPrice: {
      type: Object,
      required: true,
    },
    pressureStockLimit: {
      type: Number,
      default: 0,
    },
    stockRaw: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
    }),
    hasExtendedDisplay() {
      return COUNTRIES_WITH_EXTENDED_DISPLAY.includes(this.country)
    },
    originalPriceDisplay() {
      if (this.hasExtendedDisplay) {
        return this.$t(productThumbTranslations.originalPriceDisplay, {
          price: this.originalPrice.display,
        })
      }

      return this.originalPrice.display
    },
    translations: () => translations,
    productThumbTranslations: () => productThumbTranslations,
    attributesToDisplay() {
      return this.attributes?.map(({ attributes, label }) => ({
        label,
        value: attributes || this.$t(translations.notDefinedAttribute),
      }))
    },
    displayVanishingTag() {
      return this.isRecommendation && this.isVanishing
    },
    displayRecoTag() {
      return this.isRecommendation && !this.isVanishing
    },
  },
  methods: {
    // This method is replacing :nth-child(3) than does not exist in Tailwind v2
    isMultipleOfThree: (index) => {
      return (index + 1) % 3 === 0
    },
  },
}
